module.exports = __webpack_public_path__ + "img/soporte-tecnico-services.ecd09f0d.jpg";